import { render, staticRenderFns } from "./CustomStyle.vue?vue&type=template&id=080e281c&scoped=true&"
import script from "./CustomStyle.vue?vue&type=script&lang=js&"
export * from "./CustomStyle.vue?vue&type=script&lang=js&"
import style0 from "./CustomStyle.vue?vue&type=style&index=0&id=080e281c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080e281c",
  null
  
)

export default component.exports